// extracted by mini-css-extract-plugin
module.exports = {"opt_container":"appOtp_opt_container__6V_Pw","singleInput":"appOtp_singleInput__GR6zp"};